import React, { useEffect, useRef, useState } from "react";
import AppHeader from "../../../components/header";
import { handleOpenSnackBar } from "../../../utils/helper";
import { getAllEquipment } from "../../../services/EquipmentApi";
import AddEditBroadBand from "../broadband/AddEditBroadbandDialog";
import { Box, Stack, Typography } from "@mui/material";
import GlobalButton from "../../../components/button";
import AddIcon from "@mui/icons-material/Add";
import DynamicTable from "../../../components/dynamicTable";
import AddEditEquipmentDialog from "./AddEditEquipmentDialog";
import AppLoader from "../../../components/loader";

const tableHeader = [
  "Created At",
  "Name",
  "One-off Cost",
  "Monthly Price",
  "Actions",
];

const displayRows = [
  "lead_created_date",
  "name",
  "oneOffCostPrice",
  "monthlyPrice",
  "actions",
];

const EquipmentPage = () => {
  const openAddEditDialog = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allEquipments, setAllEquipments] = useState([]);

  useEffect(() => {
    fetchAllEquipment();
  }, []);

  const fetchAllEquipment = async () => {
    try {
      setIsLoading(true);
      const response = await getAllEquipment();
      if (response?.data.status === "success") {
        let data = response?.data.data;
        setAllEquipments(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading}/>
      <Box>
        <Stack
          direction={"row"}
          alignItems={"flex-end"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
          gap={2}
          mb={2}
        >
          <Typography
            variant="primaryText"
            component={"h1"}
            fontSize={{ xs: "1.5rem", md: "1.75rem" }}
          >
            List Of Equipments
          </Typography>
          <GlobalButton
            variant="custom_gradient"
            title="Add Equipment"
            startIcon={<AddIcon />}
            style={{
              width: { xs: "100%", sm: "auto" },
              borderRadius: "100px",
            }}
            handleClickBtn={() =>
              openAddEditDialog.current.openDialog({
                type: "add",
                data: null,
                getData: fetchAllEquipment,
              })
            }
          />
        </Stack>

        <DynamicTable
          tableData={allEquipments || []}
          displayRows={displayRows}
          tableHeader={tableHeader}
          showEdit={true}
          handleEdit={(row) => {
            openAddEditDialog.current.openDialog({
              type: "edit",
              data: row,
              getData: fetchAllEquipment,
            });
          }}
        />
        {allEquipments?.length === 0 && isLoading === false && (
          <Typography variant="h5" fontWeight={600} textAlign={"center"}>
            No Data Found !
          </Typography>
        )}

        <AddEditEquipmentDialog ref={openAddEditDialog} />
      </Box>
    </AppHeader>
  );
};

export default EquipmentPage;
